import { Rule, RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { emailRegExp } from 'enums/regExp';

export const emailCheckValidation = (getValueFrom: string): Rule[] => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || emailRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_EMAIL</TranslateText>);
        }
    }),
    ({ getFieldValue }) => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || getFieldValue(getValueFrom) === value) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_EMAIL_SHODA</TranslateText>);
        }
    })
];

export default emailCheckValidation;
